<template>
  <div class="page-shell">
    <div class="page-header">
      <div class="page-header__titles">
        <h1 class="page-title">Attendance Logs</h1>
        <p class="page-subtitle">
          Import, generate, and review employee attendance records
        </p>
      </div>
      <div class="page-actions">
        <import-attendance />
        <generate-attendance-modal />
      </div>
    </div>

    <div class="content-card">
      <v-text-field
        label="Search attendance"
        v-model="attendance_search"
        outlined
        dense
        clearable
        prepend-inner-icon="mdi-magnify"
        hide-details
        class="mb-4"
      ></v-text-field>

      <v-data-table
        :search="attendance_search"
        :items="all_attendances"
        :headers="attendance_headers"
      >
        <template v-slot:[`item.type`]="{ item }">
          <v-chip small :color="item.type == 1 ? 'error' : 'primary'" outlined>
            <v-icon left x-small>{{
              item.type == 1 ? "mdi-logout" : "mdi-login"
            }}</v-icon>
            {{ item.type == 1 ? "Out" : "In" }}</v-chip
          >
        </template>
      </v-data-table>
    </div>

    <v-row class="mt-6">
      <v-col cols="12" md="6">
        <div class="content-card fill-height">
          <h3 class="info-card-title success--text">
            <v-icon color="success" class="mr-2"
              >mdi-lightbulb-on-outline</v-icon
            >
            Things to note
          </h3>
          <ul class="info-list">
            <li>
              Your attendances is stored in the cloud within your account.
              Incase the biometric device fails, you will still get your list of
              attendances
            </li>
            <li>
              Only the administrator can alter the date of each attendance
              entry.
            </li>
            <li>
              Incase of technical issues, report/contact the system developer
              janmichaelbesinga873@gmail.com (Mr. Jan Michael Besinga).
            </li>
            <li>
              Changes and updates to the system will be applied on all users.
              Hence, you will experience the latest and updated features 24/7.
            </li>
            <li>Support by spreading the good news.</li>
          </ul>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="content-card fill-height">
          <h3 class="info-card-title primary--text">
            <v-icon color="primary" class="mr-2"
              >mdi-rocket-launch-outline</v-icon
            >
            For first time users
          </h3>
          <ol class="info-list">
            <li>
              Make sure the device is registered. Go to Account Information
              Section.
            </li>
            <li>
              Before importing attendance, make sure you've already registered
              each employees and departments. Go to Employees, and Departments
              section.
            </li>
            <li>
              You can only view the attendance when it is imported into the
              system.
            </li>
            <li>
              You need to generate attendance first before you can see the list
              of attendances.
            </li>
          </ol>
        </div>
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center mt-6">
      <v-col cols="6" md="4">
        <v-img src="@/assets/device_logo.png" contain max-height="80"></v-img>
        <p class="text-center caption mt-4 text--secondary">
          Maintained and developed by: Jan Michael Besinga | 2024
          <br />
          <span class="caption">Version {{ packageJson.version }}</span>
        </p>
      </v-col>
    </v-row>

    <alert :text="alert_message" :type="alert_type" v-if="show_alert"></alert>
  </div>
</template>
<script>
import packageJson from "../../package.json";
import { mapActions, mapGetters } from "vuex";
import ImportAttendance from "../components/Attendance/importAttendance.vue";
import GenerateAttendanceModal from "../components/Attendance/generateAttendanceModal.vue";
export default {
  components: {
    ImportAttendance,
    GenerateAttendanceModal,
  },
  data() {
    return {
      attendance_search: "",
      show_alert: false,
      alert_message: "",
      alert_type: "",
      packageJson: packageJson,
      days: [],

      generate_loading_button: false,
      custom_search_form: {
        name: "",
      },
      form: {
        year: "",
        month: "",
        department_id: "",
        date_to: "",
        date_from: "",
        employment_status: "",
        device_id: "",
      },

      attendance_headers: [
        { text: "ID", value: "userid" },
        { text: "Name", value: "employee.name" },
        { text: "Time Stamp", value: "timestamp" },
        { text: "Type", value: "type" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",

      attendances: "attendance/attendances",
      employees: "employee/employees",
      attendance_request_info: "attendance/attendance_request_info",
      all_attendances: "attendance/all_attendances",
    }),
  },
  async created() {
    this.table_loader = true;
    if (this.employees.length <= 0) await this.get_employees();

    if (this.all_attendances.length <= 0) await this.get_all_attendances();
    await this.get_devices();
    this.table_loader = false;

    var x;
    for (x = 1; x <= 31; x++) {
      this.days.push(x);
    }
  },
  methods: {
    ...mapActions({
      get_all_attendances: "attendance/get_all_attendances",
      generate_attendance: "attendance/generate_attendance",
      get_departments: "department/get_departments",
      get_employees: "employee/get_employees",
      get_devices: "device/get_devices",
    }),

    async submit() {
      this.generate_loading_button = true;
      if (!this.form.department_id || !this.form.month) {
        this.show_alert_bar("Please check all fields!", "error");
        this.generate_loading_button = false;
        return;
      }
      await this.generate_attendance(this.form);
      this.generate_loading_button = false;
      this.show_alert_bar("Sucessfully Generated!", "success");
    },

    show_alert_bar(message, type) {
      this.show_alert = true;
      this.alert_message = message;
      this.alert_type = type;
      setTimeout(() => {
        this.show_alert = false;
      }, 6000);
    },
  },
};
</script>
<style scoped>
.info-card-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 12px;
}
.info-list {
  padding-left: 20px;
  color: #475569;
  font-size: 0.88rem;
}
.info-list li {
  margin-bottom: 8px;
  line-height: 1.5;
}
</style>
